module.exports = __webpack_public_path__ + "img/myhead.5e63762f.png";